<template>
  <img class="loading_icon" :src="getImageUrl('logo_transparent.png')" />
</template>

<script lang="ts">
import utilService from "@/services/util.service";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const getImageUrl = utilService.getImageUrl;

    return {
      getImageUrl,
    };
  },
});
</script>

<style lang="scss">
@keyframes imageShimmer {
  0% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
.dummy_loading {
  position: relative;
  .loading_icon {
    width: 40px !important;
    height: 35px !important;
    position: relative;
    animation-name: imageShimmer;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
}
</style>
